import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Spinner } from "@material-tailwind/react";
import toast from "react-hot-toast";
import ConfirmPayment from "../../../common/shared/ConfirmPayment";
import * as api from "../../../redux/api/nfc_card/nfc_card_api";
import * as types from "../../../redux/constants/nfc_card_constants";

function NfcCardPay({ id, amount, autoOpen = false, onAutoOpen }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const handleOpen = () => setOpen((prev) => !prev);

  useEffect(() => {
    if (autoOpen) {
      setOpen(true);
      if (onAutoOpen) {
        onAutoOpen();
      }
    }
  }, [autoOpen, onAutoOpen]);

  const handleLive = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.nfcCardPayment(id);
      const { error, data } = response;

      if (error) {
        toast.error(error);
        dispatch({ type: types.NFC_CARD_PAYMENT_FAILURE, payload: error });
      } else {
        dispatch({ type: types.NFC_CARD_PAYMENT_SUCCESS, payload: data });

        const receiptUrl =
          data?.card?.receipt?.url ||
          data?.card?.new_receipt?.url ||
          data?.receipt?.url;

        if (receiptUrl) {
          window.location.href = receiptUrl;
        } else {
          toast.error("Payment link could not be generated. Please try again.");
        }
      }
    } catch (error) {
      toast.error("No Connection");
      dispatch({ type: types.NFC_CARD_PAYMENT_FAILURE, payload: "No Connection" });
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button color="pink" onClick={handleOpen} disabled={loading}>
        {loading ? <Spinner color="white" /> : "Make Payment"}
      </Button>

      {open && (
        <ConfirmPayment
          open={open}
          setOpen={setOpen}
          title="Electronic"
          amount={amount || 0}
          loading={loading}
          handleConfirm={(e) => handleLive(e)}
          handleClose={handleOpen}
        />
      )}
    </>
  );
}

export default NfcCardPay;
